import { z } from 'zod';
import { useGenericForm } from '@/hooks/use-generic-form';
import { authSchema } from '@/validation/auth.schema';
import { AxiosError } from 'axios';
import { useSignIn } from '@/api/auth/auth.hooks.ts';
import { TokenResponse } from '@/api/auth/auth.types.ts';

type LoginFormData = z.infer<typeof authSchema>;

export const useLoginForm = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (response: TokenResponse) => void;
  onError?: (error: AxiosError<any>) => void;
}) => {
  const signInMutation = useSignIn();

  return useGenericForm<LoginFormData, TokenResponse>({
    schema: authSchema,
    mutation: signInMutation,
    onSuccess,
    onError,
  });
};
